


export const roles_select = ['SUPERADMIN','ADMIN','GALPONERO','CONDUCTOR','SECRETARIA','CLIENTE','ASISTENTE-GERENCIA','ADMIN-GRANJA'];
export const generoPollo = ['HEMBRA', 'MACHO'];
